import { gql } from "@apollo/client"

export const GET_ACT_MULTI_DISTRICT_ADMIN = gql`
  query getACTMultiDistrictAdmin($id: String!) {
    actMultiDistrictAdmin {
      get(id: $id) {
        id
        firstName
        lastName
        email
        username
        title
        isTeacher
        isIT
        sfId
        organizationId
      }
    }
  }
`
